<template>
  <collapse-card :loading="loading" open>
    <div slot="link">
      <div class="edit-link">Сохранить</div>
    </div>
    <div slot="title">Прочее</div>
    <!--    <subtitle-divider>Общие рекомендации</subtitle-divider>-->
    <div class="block-title">Общие рекомендации</div>


    <div class="recommendation">
      <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8}"
          ref="general_recommendations"
          v-model="conclusion.general_recommendations"
          class="recommendation__input"></el-input>


    </div>

    <!--    <subtitle-divider></subtitle-divider>-->
    <div class="block-title">Рекомендуемые бады</div>

    <div v-if="products.length" class="filters">
      <el-radio-group v-model="system" @change="setFilteredProducts">
        <el-radio-button label="Все системы"></el-radio-button>
        <el-radio-button v-for="(type, index) in systemTypes"
                         :key="index"
                         :label="type"></el-radio-button>
      </el-radio-group>
    </div>
    <supplement-list :products="products"
                     @openAddSupplementModal="openAddSupplementModal"
                     @save="save"
                     add/>
    <add-supplement :visible="isVisibleAddSupplement"
                    @close="isVisibleAddSupplement = false"
                    @addNewSupplement="addNewSupplement"/>

    <div class="block-title">Рекомендуемые услуги</div>
    <procedure-list :products="conclusion.procedures"
                    @openAddProcedureModal="openAddProcedureModal"
                    @remove="remove"
                    @save="save"/>
    <add-procedure :visible="isVisibleAddProcedure"
                   :excepts="conclusion.procedures"
                   @close="isVisibleAddProcedure = false"
                   @addNewProcedure="addNewProcedure"/>

  </collapse-card>
</template>

<script>
import {mapGetters, mapActions} from "vuex"
import CollapseCard from "@/components/elements/BigCard.vue"
import SupplementList from "@/components/visit/conclusion/SupplementList.vue"
import AddSupplement from "@/views/cpanel/visit/modal/conclusion/AddSupplement.vue"
import ProcedureList from "@/components/visit/conclusion/ProcedureList.vue"
import AddProcedure from "@/views/cpanel/visit/modal/conclusion/AddProcedure.vue"

export default {
  name: "Other",
  components: {
    CollapseCard,
    SupplementList,
    AddSupplement,
    ProcedureList,
    AddProcedure
  },
  data() {
    return {
      loading: false,
      editable: false,
      system: "Все системы",
      filteredProducts: [],
      isVisibleAddSupplement: false,
      isVisibleAddProcedure: false,
    }
  },
  computed: {
    ...mapGetters("visit", {
          conclusion: "conclusion"
        }
    ),
    products() {
      return this.filteredProducts.length ? this.filteredProducts : this.conclusion.market_products
    },
    systemTypes() {

      const allSystemTypes = this.conclusion.market_products.reduce((acc, product) => {

        if (!product.human_system_types) return []
        const systemType = product.human_system_types.map(type => {
          return type.title
        })
        return [...acc, ...systemType]
      }, [])
      return allSystemTypes.filter((type, index) => allSystemTypes.indexOf(type) === index)
    }
  },
  filters: {
    empty(value) {
      return value === '' ? 'Данные остутствуют' : value
    }
  },
  methods: {
    ...mapActions({
      addMarketProduct: "visit/ADD_MARKET_PRODUCT",
      addMarketProcedure: "visit/ADD_MARKET_PROCEDURE",
      updateConclusion: "visit/UPDATE_CONCLUSION",
    }),
    openAddSupplementModal() {
      this.isVisibleAddSupplement = true
    },
    openAddProcedureModal() {
      console.log('openAddProcedureModal')
      this.isVisibleAddProcedure = true
    },
    editEditable() {
      this.editable = true
      this.$nextTick(() => {
        this.$refs.general_recommendations.focus()
      })
    },
    addNewSupplement(data) {
      this.addMarketProduct(data)
      this.save()
    },
    addNewProcedure (data) {
      console.log('addNewProcedure', data)

      this.addMarketProcedure(data)
      this.save()
    },
    save() {
      this.editable = false
      this.loading = true
      this.updateConclusion(this.conclusion).then(() => {

        this.$notify.success({
          title: "Успешно",
          message: "Данные обновлены",
        })
      }).catch((response) => {
        this.$notify.error({
          title: "Ошибка 😕",
          message: response.response.data.message
        })
      }).finally(() => {
        this.loading = false
      })
    },
    remove(id) {
      this.conclusion.procedures = this.conclusion.procedures.filter(item => item.id !== id)
      this.save()
    },
    setFilteredProducts() {
      this.filteredProducts = this.conclusion.market_products.filter(product => {
        return product.human_system_types.some(type => {
          return type.title === this.system
        })
      })
    },

  }
}

</script>
<style lang="scss" scoped>
.recommendation {
  white-space: pre-wrap;

  display: flex;
  justify-content: space-between;
  align-items: center;

  &__text {
    margin-top: 0;
    margin-right: 12px;
    margin-bottom: 0;

    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.005em;
    color: #111111
  }

  &__input {
    margin-right: 12px;
  }
}

.edit-icon {
  color: #8E8E93;
  cursor: pointer;
  font-size: 13px;

  &:hover {
    opacity: 0.5
  }
}

.filters {
  margin-bottom: 8px;
}

.block-title {
  margin: 16px 0;

  font-weight: 600;
  font-size: 20px;
  line-height: 1;


  color: #111111;
}

.edit-link {
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
  line-height: 26px;

  color: #43D3B3;

  &:hover {
    opacity: .5;
  }
}
</style>